import React from "react";

/** @param {"hero" | "section"} variant */
function HighlightText({ text, variant = "section" }) {
  if (variant === "hero") {
    return (
      <span className="bg-gradient-to-b from-[#FF512F] to-[#F09819] bg-clip-text font-bold text-transparent">
        {text}
      </span>
    );
  }
  return <span className="font-bold text-caribbeangreen-100">{text}</span>;
}

export default HighlightText;
